module.exports = __webpack_public_path__ + "img/canary-islands.e0e16b07.svg";